export default __webpack_public_path__ + "static/media/metrics.37fd47b1.jfif";